module.exports = {
    baseRouter: '',
    menuList: [{
        mid: "0",
        name: {
            en: "Gate",
            vn: "Cổng vào"
        },
        link: {
            en: `./LCDF-360-EN-20221021/index.htm?skip-loading&media-index=1`,
            vn: `./LCDF-360-Vi-20221021/index.htm?skip-loading&media-index=1`
        },
        list: [],
        display: true,
    },
    {
        mid: "1",
        name: {
            en: "Entrance",
            vn: "Cổng chính"
        },
        link: {
            en: `./LCDF-360-EN-20221021/index.htm?skip-loading&media-index=2`,
            vn: `./LCDF-360-Vi-20221021/index.htm?skip-loading&media-index=2`
        },
        list: [],
        display: true,
    },
    {
        mid: "2",
        name: {
            en: "Lobby",
            vn: "Sảnh chính"
        },
        link: {
            en: `./LCDF-360-EN-20221021/index.htm?skip-loading&media-index=3`,
            vn: `./LCDF-360-Vi-20221021/index.htm?skip-loading&media-index=3`
        },
        list: [],
        display: true,
    },
    {
        mid: "3",
        name: {
            en: "1.1 Student service centre",
            vn: "Phòng đón tiếp"
        },
        link: {
            en: `./LCDF-360-EN-20221021/index.htm?skip-loading&media-index=6`,
            vn: `./LCDF-360-Vi-20221021/index.htm?skip-loading&media-index=6`
        },
        list: [],
        display: true,
    },
    {
        mid: "4",
        name: {
            en: "1.2 Design studio",
            vn: "Phòng học Thiết kế đồ họa"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.2`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.2`
        },
        list: [],
        display: true,
    },
    {
        mid: "5",
        name: {
            en: "1.3 Design studio",
            vn: "Phòng học Thiết kế Nội thất"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.3`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.3`
        },
        list: [],
        display: true,
    },
    {
        mid: "6",
        name: {
            en: "1.4 Library",
            vn: "Thư viện"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.4`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.4`
        },
        list: [],
        display: true,
    },
    {
        mid: "7",
        name: {
            en: "1.5 Design shop",
            vn: "Shop"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.5`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.5`
        },
        list: [],
        display: true,
    },
    {
        mid: "8",
        name: {
            en: "",
            vn: ""
        },
        link: {
            en: ``,
            vn: ``
        },
        list: [],
        display: false,
    },
    {
        mid: "9",
        name: {
            en: "1.7 Print centre",
            vn: "Trung tâm in ấn"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.7`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.7`
        },
        list: [],
        display: true,
    },
    {
        mid: "10",
        name: {
            en: "1.8 Mac lab",
            vn: "Phòng Mac lab"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.8`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=1.8`
        },
        list: [],
        display: true,
    },
    {
        mid: "11",
        name: {
            en: "2.1 illustration studio",
            vn: "Phòng học Vẽ"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.1`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.1`
        },
        list: [],
        display: true,
    },
    {
        mid: "12",
        name: {
            en: "2.2 Textile studio",
            vn: "Phòng học chất liệu"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.2`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.2`
        },
        list: [],
        display: true,
    },
    {
        mid: "13",
        name: {
            en: "2.3 Design studio",
            vn: "Phòng học Thời trang"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.3`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.3`
        },
        list: [],
        display: true,
    },
    {
        mid: "14",
        name: {
            en: "2.4 Meeting room",
            vn: "Phòng họp"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.4`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.4`
        },
        list: [],
        display: true,
    },
    {
        mid: "15",
        name: {
            en: "2.5 Photography studio",
            vn: "Phòng Nhiếp ảnh"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.5`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.5`
        },
        list: [],
        display: true,
    },
    {
        mid: "16",
        name: {
            en: "2.6",
            vn: ""
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.6`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.6`
        },
        list: [],
        display: false,
    },
    {
        mid: "17",
        name: {
            en: "2.7 Pattern studio",
            vn: "Phòng Thiết kế mẫu rập"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.7`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.7`
        },
        list: [],
        display: true,
    },
    {
        mid: "18",
        name: {
            en: "2.8 Machine studio",
            vn: "Phòng hoàn thiện sản phẩm"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.8`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.8`
        },
        list: [],
        display: true,
    },
    {
        mid: "19",
        name: {
            en: "2.9 3D workshop",
            vn: "Phòng thực hành 3D"
        },
        link: {
            en: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.9`,
            vn: `https://beyond.3dnest.cn/play/index.html?m=45563e44_7NRT_b6f9&o=2.9`
        },
        list: [],
        display: true,
    },
    {
        mid: "20",
        name: {
            en: "Canteen",
            vn: "Canteen"
        },
        link: {
            en: `./LCDF-360-EN-20221021/index.htm?skip-loading&media-index=7`,
            vn: `./LCDF-360-Vi-20221021/index.htm?skip-loading&media-index=7`
        },
        list: [],
        display: true,
    },
    {
        mid: "21",
        name: {
            en: "Swimming pool",
            vn: "Bể bơi"
        },
        link: {
            en: `./LCDF-360-EN-20221021/index.htm?skip-loading&media-index=8`,
            vn: `./LCDF-360-Vi-20221021/index.htm?skip-loading&media-index=8`
        },
        list: [],
        display: true,
    },
    ],
    display: true,
};